"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mitt = _interopRequireDefault(require("mitt"));
var eventHub = new _mitt.default();
var _default = exports.default = eventHub;